import React, { createContext, useContext, useState, useMemo } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen((prevState) => !prevState);
  };

  const contextValue = useMemo(() => ({ isOpen, toggleSidebar }), [isOpen, toggleSidebar]);

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => useContext(SidebarContext);
